(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["avada-article-product-compat"] && !Shopify.designMode) return;
  try {
    if (
    document.querySelector('.article .Avada-Tool__DynamicProduct') &&
    typeof window.Swiper !== 'function'
  ) {
    window.Swiper = class AvadaArticleStaticGrid {
      constructor(selector, parameters) {
        this.el = document.querySelector(selector);
        this.params = parameters;
      }

      destroy() {}
    };
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["digital-content-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('digital-content-consent')) {
    class DigitalContentConsent extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('.digital-content-consent__checkbox');
        if (!this.checkbox) return;

        this.installThemeValidationMessage();
        this.handleChange = this.handleChange.bind(this);
        this.checkbox.addEventListener('change', this.handleChange);
        this.handleChange();
      }

      disconnectedCallback() {
        if (this.checkbox && this.handleChange) {
          this.checkbox.removeEventListener('change', this.handleChange);
        }
      }

      handleChange() {
        const message = this.checkbox.checked ? '' : this.checkbox.dataset.validationMessage;
        this.checkbox.setCustomValidity(message || '');
      }

      installThemeValidationMessage() {
        const validation = window.theme?.formValidation;
        if (!validation) {
          document.addEventListener('DOMContentLoaded', () => this.installThemeValidationMessage(), { once: true });
          return;
        }

        if (validation.digitalContentConsentMessageInstalled) return;

        const originalMessageFor = validation.messageFor.bind(validation);
        validation.messageFor = function(field) {
          if (field.validity.valueMissing && field.dataset.validationMessage) {
            return field.dataset.validationMessage;
          }
          return originalMessageFor(field);
        };
        validation.digitalContentConsentMessageInstalled = true;
      }
    }

    customElements.define('digital-content-consent', DigitalContentConsent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root) => {
    root.querySelectorAll('.newsletter-form').forEach((form) => {
      const configuration = form.querySelector('[data-newsletter-gift-direct]');
      if (!configuration || form.dataset.newsletterGiftBound === 'true') return;
      form.dataset.newsletterGiftBound = 'true';
      form.addEventListener('submit', async (event) => {
        if (!form.checkValidity()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.dataset.newsletterGiftSubmitting === 'true') return;
        form.dataset.newsletterGiftSubmitting = 'true';
        const emailInput = form.querySelector('input[type="email"]');
        const button = form.querySelector('button[type="submit"]');
        const feedback = form.querySelector('[data-newsletter-feedback]');
        const email = emailInput.value.trim();
        const originalLabel = button.getAttribute('aria-label');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-label', configuration.dataset.loadingCopy);
        feedback.hidden = true;
        feedback.classList.remove('newsletter-form__feedback--success', 'newsletter-form__feedback--error');
        try {
const eventId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
          const eventPayload = {
            data: {
              type: 'event',
              attributes: {
                properties: {source: 'footer_needle_45', locale: document.documentElement.lang || 'de'},
                unique_id: eventId,
                metric: {data: {type: 'metric', attributes: {name: configuration.dataset.eventName}}},
                profile: {data: {type: 'profile', attributes: {email}}}
              }
            }
          };
          const eventRequest = fetch(`https://a.klaviyo.com/client/events?company_id=${encodeURIComponent(configuration.dataset.companyId)}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/vnd.api+json', revision: '2026-07-15'},
            body: JSON.stringify(eventPayload),
            keepalive: true
          }).catch(() => null);
          const subscription = new URLSearchParams({
            g: configuration.dataset.listId,
            email,
            '$fields': '$consent,newsletter_gift_source',
            '$consent': 'email',
            newsletter_gift_source: 'footer_needle_45'
          });
          const subscriptionRequest = fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: subscription.toString(),
            keepalive: true
          }).then(async (response) => ({response, result: await response.json().catch(() => null)})).catch(() => null);
          const [eventResponse, subscriptionOutcome] = await Promise.all([eventRequest, subscriptionRequest]);
          const eventAccepted = eventResponse?.status === 202;
          const subscriptionAccepted = Boolean(subscriptionOutcome?.response.ok && subscriptionOutcome?.result?.success);
          if (!eventAccepted || !subscriptionAccepted) throw new Error('Newsletter signup or gift event failed');
          feedback.textContent = configuration.dataset.successCopy;
          feedback.classList.add('newsletter-form__feedback--success');
          feedback.hidden = false;
          form.reset();
        } catch (error) {
          feedback.textContent = configuration.dataset.errorCopy;
          feedback.classList.add('newsletter-form__feedback--error');
          feedback.hidden = false;
        } finally {
          delete form.dataset.newsletterGiftSubmitting;
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          button.removeAttribute('aria-busy');
          button.setAttribute('aria-label', originalLabel);
        }
      }, { capture: true });
    });
  };
  const start = () => initialize(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
